import React from 'react';

import WidgetCheckIcon from '../../../assets/images/widget-check.svg';

const WIDGET_ATTENTION_LABELS = {
  thinking: 'Thinking',
  working: 'Generating',
  message: 'New message',
  ready: 'Preview ready',
  failed: 'Generation failed',
};

export const WidgetAttentionIndicator = React.memo(function WidgetAttentionIndicator({ state }) {
  const label = WIDGET_ATTENTION_LABELS[state];
  if (!label) return null;

  return (
    <>
      {state === 'thinking' || state === 'working' ? (
        // Same size-4 slot as the dots, so shrinking the ring inside it leaves the text
        // beside it exactly where it was.
        <span aria-hidden className="flex size-4 shrink-0 items-center justify-center">
          <span className="size-3.5 animate-spin rounded-full [background:conic-gradient(from_90deg,#000_0deg,#f8fafb_360deg)] [mask:radial-gradient(closest-side,transparent_calc(100%_-_2px),#000_calc(100%_-_2px))]" />
        </span>
      ) : state === 'ready' ? (
        <span aria-hidden className="flex size-4 shrink-0 items-center justify-center rounded-full bg-green-500 text-white">
          <WidgetCheckIcon className="h-[6px] w-[7px]" />
        </span>
      ) : state === 'message' ? (
        <span aria-hidden className="flex size-4 shrink-0 items-center justify-center">
          <span className="size-2 rounded-full bg-idle-blue" />
        </span>
      ) : (
        <span aria-hidden className="flex size-4 shrink-0 items-center justify-center">
          <span className="size-2 rounded-full bg-red-500" />
        </span>
      )}
      <span className="sr-only">{label}</span>
    </>
  );
});

export default WidgetAttentionIndicator;
